(function() {
	const numberTabRadios = document.getElementsByClassName("js-number-radio");

	for (let i = 0; i < numberTabRadios.length; i++) {
		numberTabRadios[i].addEventListener("change", function() {

			const mobileNumberCnts = document.getElementsByClassName("js-customer-mobile-number-cnt");

			if (this.value == 1) {
				for (let i = 0; i < mobileNumberCnts.length; i++) {
					mobileNumberCnts[i].classList.add("hidden");
				}
			}
			else {
				for (let i = 0; i < mobileNumberCnts.length; i++) {
					mobileNumberCnts[i].classList.remove("hidden");
				}
			}
		});
	}
})();